import { CMS } from "../../components/cms/cms";
import { createStore } from "solid-js/store";
import { Show, onMount } from "solid-js";
import { loadAboutUsCms, loadAds, setPageTitle, setSubMenu } from "../../app";

type State = {
    isContentReady: boolean;
}

export function HomeAboutUsPage() {
    const [state, setState] = createStore<State>({ isContentReady: false } as State);
    onMount(async () => {
        await loadAboutUsCms();
        await loadAds("7th-arc-salon/introduction");
        setSubMenu("About Us");
        setPageTitle({ id: "7th-arc-salon/about-us::page-title", text: "About us" });
        setState({ isContentReady: true });
    });
    return (
        <>
            <Show when={state.isContentReady}>
                <div class="text-CMS">
                    <div class="container">
                        <CMS id="7th-arc-salon/about-us::introduction">Introduction</CMS>
                        <h2 class="staff-listing-heading">
                            <CMS id="7th-arc-salon/about-us::heading/our-staff">Our Staff</CMS>
                        </h2>
                    </div>
                    <section class="staff-listing">
                        <div class="staff-row staff-row-light">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-4 col-lg-4">
                                        <CMS id="staff-listing::fred-ross"></CMS>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <CMS id="staff-listing::kara-ross:17th-arc-salon"></CMS>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <CMS id="staff-listing::iian-neill"></CMS>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="staff-row staff-row-dark">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-4 col-lg-4">
                                        <CMS id="staff-listing::angela-swanson-jones"></CMS>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <CMS id="staff-listing::hongbin-zhang"></CMS>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="staff-row staff-row-light">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-4 col-lg-4">
                                        <CMS id="staff-listing::frank-gatti"></CMS>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <CMS id="staff-listing::yvette-lytle"></CMS>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <CMS id="staff-listing::sabrina-foland"></CMS>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="staff-row staff-row-dark">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-4 col-lg-4">
                                        <CMS id="staff-listing::michele-carnevale"></CMS>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <CMS id="staff-listing::sherry-ross"></CMS>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <CMS id="staff-listing::sean-colon"></CMS>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container">
                            <div class="staff-row staff-row-light">
                                <div class="text-center">
                                    <CMS id="staff-listing::thank-you"></CMS>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </Show>
        </>
    )
}